import { createFeatureSelector, createSelector } from '@ngrx/store';
import { HomeState } from './../state/home.state';

export const selectHomeState = createFeatureSelector<HomeState>('home');

export const selectCalendarEvents = createSelector(
  selectHomeState,
  (state) => state.calendarEvents
);

export const selectEmployeeHours = createSelector(
  selectHomeState,
  (state) => state.employeeHours
);

export const selectEmployeeStatus = createSelector(
  selectHomeState,
  (state) => state.employeeStatus
);

export const selectLoading = createSelector(
  selectHomeState,
  (state) => state.loading
);

export const selectError = createSelector(
  selectHomeState,
  (state) => state.error
);
